/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from 'react';
import { PageProps } from 'gatsby';
import Header from '../header/header';
import Footer from '../footer/footer';

const Layout: React.FC<PageProps<{ is404?: boolean }>> = ({
  children,
  location,
  data
}) => {
  return (
    <>
      <Header data-test-id="header" location={location} />
      <main data-test-id="main">{children}</main>
      <Footer data-test-id="footer" data={{ is404: data?.is404 }}></Footer>
    </>
  );
};

export default Layout;
